module.exports = __webpack_public_path__ + "img/header-1.b8d80426.png";